/**
 * Utility function to help with exhaustive checks in TypeScript.
 *
 * This function is used to ensure that all possible values of a union type
 * are handled in switch statements or conditional logic.
 *
 * @example
 * ```typescript
 * type Status = 'loading' | 'success' | 'error';
 *
 * function handleStatus(status: Status): string {
 *   switch (status) {
 *     case 'loading':
 *       return 'Loading...';
 *     case 'success':
 *       return 'Success!';
 *     case 'error':
 *       return 'Error occurred';
 *     default:
 *       return notReachable(status); // TypeScript error if Status type is extended
 *   }
 * }
 * ```
 */
export const notReachable = (value: never): never => {
  throw new Error(`Not reachable: ${value}`);
};
